// --> React
import React from 'react';

// --> Packages
import { Icon } from '@iconify/react';

import { STAR_FILLED } from 'icons';

// --> Component Imports
import Style from './customerReview.module.scss';

export default function CustomerReview({ imgLink, comment, name }) {
	return (
		<div className={Style.ReviewWrapper}>
			<div className={Style.Left}>
				<img src={imgLink} alt='Review Avatar' />
				<div className={Style.RatingWrapper}>
					<Icon icon={STAR_FILLED} />
					<Icon icon={STAR_FILLED} />
					<Icon icon={STAR_FILLED} />
					<Icon icon={STAR_FILLED} />
					<Icon icon={STAR_FILLED} />
				</div>
			</div>
			<div className={Style.Right}>
				<p>{comment}</p>
				<p>- {name}</p>
			</div>
		</div>
	);
}
